import Grid from '@mui/material/Grid';
import { useEffect, useRef, useState } from 'react';
import { PopupComponent } from '../common/PopupComponent';
import ProgressBar from '../common/ProgressBar';
import { useAppSelector } from '../../store/hooks';
import { setMessage } from '../../store/Message';
import VersionControl from '../versionControl/VersionControl';
import { useAppDispatch } from 'src/store';
import { getPoratlHost } from 'src/components/hooks/useUtil';
import forms from 'src/resources/forms.json';
import { FormLayoutBuilder, getFormData } from '@pihealth/common-ui-library';
import { sendRequest } from 'src/hooks/useFetch';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useDocumentUploads } from 'src/components/StartUp/documentUpload/useDocumentUploads';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';

import { Box, Chip } from '@mui/material';
import AppModal from 'src/components/modal';
import { useLazyGetDrugSupplyArtifactsQuery } from 'src/services/etmfDocLevel';
import { usePermissionWrapper } from '../hooks/usePermissionWrapper';

interface addDocPropTypes {
  tmfLevel?: string;
  uploadDocDialogOpen: boolean;
  setUploadDocDilogOpen: (isOpenDialog: boolean) => void;
  moduleSection: string;
  createDrugSupplyDoc?: any;
  deleteDrugSupplyDoc?: any;
  selectedRecordId?: string;
  attachedDocumentsList?: any[];
  setAttachedDocsList?: (attachedList: any[]) => void;
}
export default function DocumentUploadModel({
  tmfLevel = 'Study',
  uploadDocDialogOpen,
  setUploadDocDilogOpen,
  moduleSection = '',
  createDrugSupplyDoc,
  deleteDrugSupplyDoc,
  selectedRecordId = '',
  attachedDocumentsList = [],
  setAttachedDocsList
}: addDocPropTypes) {
  const { createMasterDocumentEtmf, getAllDocsByArtifactName, getDocLevelByArtifactName, deleteMasterDocumentETMF } =
    useDocumentUploads();

  const { ipmFileuploadErrorMsg } = useFieldTranslation();
  const dispatch = useAppDispatch();
  const [openVersion, setOpenVersion] = useState(false);
  const [selectData, setSelectData] = useState<any>([]);
  const selectedStudy: any = useAppSelector(state => state.site.selectedStudy);
  const { preferedDateFormat } = usePreferedDateFormat();

  const [metaData, setMetaData] = useState<any>({
    tmf_artifact_number: '',
    tmf_document_name: '',
    tmf_document_type: '',
    tmf_document_subtype: '',
    tmf_doc_date: new Date().toISOString().split('T')[0],
    tmf_doc_country: '',
    tmf_doc_study: '',
    tmf_doc_site: '',
    tmf_doc_level: '',
    tmf_artifact_name: '',
    tmf_doc_version_number: 1.0,
    tmf_doc_milestone: ''
  });

  const initialState = {
    tmf_artifact_number: '',
    tmf_document_name: '',
    tmf_document_type: '',
    tmf_document_subtype: '',
    tmf_doc_date: new Date().toISOString().substring(0, 10),
    tmf_doc_country: '',
    tmf_doc_study: '',
    tmf_doc_site: '',
    tmf_doc_level: 'Site',
    tmf_artifact_name: '',
    tmf_doc_version_number: 1.0,
    tmf_doc_milestone: ''
  };

  const [isLoading, setIsLoading] = useState(false);

  const postData = async (docData: any) => {
    setIsLoading(true);
    const country = metaData.tmf_doc_level === tmfLevel ? '' : metaData.tmf_doc_country;
    const site =
      metaData.tmf_doc_level === tmfLevel || metaData.tmf_doc_level === 'Country' ? '' : metaData.tmf_doc_site;
    const result: any = await createMasterDocumentEtmf({
      data: docData,
      study_id: selectedStudy,
      country,
      site_id: site,
      application: process.env.REACT_APP_NAME,
      module_section_related: moduleSection,
      parent_entity_related: ''
    });

    if (result?.data) {
      if (createDrugSupplyDoc) {
        await createDrugSupplyDoc({
          data: {
            filemaster_id: result?.data.document_data.id,
            tmf_document_id: result?.data.document_data.tmf_document_id
          },
          drug_supply_id: selectedRecordId,
          study_id: selectedStudy,
          application: process.env.REACT_APP_NAME,
          application_section: process.env.REACT_APP_CONDUCT_NAME,
          application_module_section: process.env.REACT_APP_CONDUCT_NAME
        });
        resetDocumentUpload();
        setUploadDocDilogOpen(false);
      }
    } else if (result?.error) {
      if (result?.error.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (result?.error.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      } else {
        dispatch(setMessage({ msgDetails: ipmFileuploadErrorMsg, severity: 'error' }));
      }
    }
    setIsLoading(false);
  };

  const handleCloseVersion = () => {
    resetDocumentUpload();
    setOpenVersion(false);
    setUploadDocDilogOpen(false);
    setMetaData({ ...initialState });
  };

  const handleBackVersion = () => {
    setUploadDocDilogOpen(true);
    setOpenVersion(false);
  };

  const getDocumentDetails = async (metaData: any, docData: any) => {
    setIsLoading(true);
    const country = metaData.tmf_doc_level === tmfLevel ? '' : metaData.tmf_doc_country;
    const site =
      metaData.tmf_doc_level === tmfLevel || metaData.tmf_doc_level === 'Country' ? '' : metaData.tmf_doc_site;
    const res: any = await getAllDocsByArtifactName({
      country,
      site_id: site,
      study_id: selectedStudy,
      docLevel: metaData.tmf_doc_level,
      artifactName: metaData.tmf_artifact_name,
      application: process.env.REACT_APP_NAME,
      module_section_related: moduleSection,
      parent_entity_related: ''
    });
    if (res?.isSuccess) {
      const result: any = res?.data && res?.data.selected_data.length > 0 ? res?.data.selected_data : [];
      if (result.length > 0) {
        setSelectData(result[0]);
        (metaData.tmf_doc_level === result[0].document_data.tmf_doc_level &&
          metaData.tmf_doc_study === result[0].document_data.tmf_doc_study &&
          metaData.tmf_artifact_name === result[0].document_data.tmf_artifact_name) ||
        metaData.tmf_doc_country === result[0].document_data.tmf_doc_country ||
        metaData.tmf_doc_site === result[0].document_data.tmf_doc_site
          ? setOpenVersion(true)
          : postData(docData);
      }
    } else if (res?.error) {
      postData(docData);
    }
    setIsLoading(false);
  };

  //************************************ */
  // Document upload based on FormBuilder
  const [refreshKey, setRefreshKey] = useState(0);
  const uploadDocumentFormRef: any = useRef(null);
  const [resData, setResData] = useState({});
  const [deleteDocFileMasterId, setDeleteFileMasterDocId] = useState({
    document_id: '',
    tmf_document_id: '',
    fileMasterId: ''
  });
  const { checkPermission } = usePermissionWrapper();
  const uploadDoc = forms.uploadDocument;
  const { formFields: uploadDocFields, rules: uploadeDocRules } = getFormData(uploadDoc.groups);
  const { groups: uploadDocGroups } = uploadDocFields;
  const uploadDocumentformGroup = forms.uploadDocumentDS;
  const {
    formFields: uploadeDocumentFormFields,
    defaultValues: uploadeDocumentDefaultValues = {},
    rules: uploadeDocumentRules
  } = getFormData(uploadDocumentformGroup.groups, {
    TMFLEVES: [
      {
        code: 'Project',
        displayName: 'Project',
        key: 'Project'
      },
      {
        code: 'Study',
        displayName: 'Study',
        key: 'Study'
      },
      {
        code: 'Country',
        displayName: 'Country',
        key: 'Country'
      },
      {
        code: 'Site',
        displayName: 'Site',
        key: 'Site'
      }
    ]
  });
  const [uploadInitialValues, setUploadInitialValues] = useState({
    ...uploadeDocumentDefaultValues,
    tmf_doc_level: tmfLevel,
    tmf_doc_study: selectedStudy
  });
  const { groups: uploadDocumentGroups } = uploadeDocumentFormFields;
  const [deleteDocPopup, setDeleteDocPopup] = useState(false);
  const [cancelDocPopup, setCancelDocPopup] = useState(false);
  const [docSubmitEnabled, setDocSubmitEnabled] = useState(false);
  const [selectedArtifact, setSelectedArtifact] = useState('');
  const [getDrugSupplyArtifacts] = useLazyGetDrugSupplyArtifactsQuery();
  // getting artifact names and error handling for 401 and 403
  const getTmfDataResponse = async (level: any) => {
    let tmfLevelQueryResponse: any = [];
    const result: any = await getDrugSupplyArtifacts({
      tmf_level: level,
      study_id: selectedStudy,
      application: process.env.REACT_APP_NAME,
      module_section_related: moduleSection,
      parent_entity_related: ''
    });
    if (result?.isSuccess) {
      tmfLevelQueryResponse = result?.data.map((item: string) => {
        return {
          code: item,
          key: item,
          displayName: item
        };
      });
    } else if (result?.isError) {
      if (result?.error.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (result?.error.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
    }
    uploadDocumentGroups.map((obj: any) => {
      obj?.fields.map((field: any) => {
        if (field.name == 'tmf_artifact_name') {
          field.values = tmfLevelQueryResponse;
        }
      });
    });
  };
  // Open document to view in eTMF Document Viewer
  const openDoucmentViewer = (item: any) => {
    setUploadDocDilogOpen(false);
    window.parent.postMessage(
      {
        action: 'PUSH_APP',
        slug_id: process.env.REACT_APP_ETMF_SLUG,
        //Send Document ID and Study ID only for the Study Level document viewing
        viewerDocument: {
          document_id: item.document_data.id,
          study_id: item.document_data.tmf_doc_study
        }
      },
      getPoratlHost()
    );
  };
  const handleDocDelete = (docFileMasterId: string, tmfDocId: string, docDocumentId: string) => {
    setDeleteFileMasterDocId({ document_id: docDocumentId, tmf_document_id: tmfDocId, fileMasterId: docFileMasterId });
    setDeleteDocPopup(true);
  };
  const handleDocDeletePopupClose = () => {
    setDeleteDocPopup(false);
  };
  const resetDocumentUpload = () => {
    setUploadInitialValues({
      ...uploadInitialValues,
      document_upload: null,
      tmf_doc_version_number: '',
      tmf_document_name: '',
      tmf_artifact_name: '',
      tmf_doc_milestone: '',
      tmf_document_type: '',
      tmf_document_subtype: '',
      tmf_artifact_number: '',
      tmf_doc_date: ''
    });
    uploadDocumentGroups.map((obj: any) => {
      obj?.fields.map((field: any) => {
        if (field.name == 'tmf_document_name' || field.name == 'tmf_artifact_name') {
          field.disabled = true;
        }
      });
    });
    setAttachedDocsList && setAttachedDocsList([]);
    setDocSubmitEnabled(false);
  };
  const handleDocDeleteconfirm = async () => {
    setIsLoading(true);
    try {
      handleDocDeletePopupClose();
      await deleteMasterDocumentETMF({
        file_master_id: deleteDocFileMasterId.fileMasterId,
        study_id: selectedStudy,
        application: process.env.REACT_APP_NAME,
        module_section_related: process.env.REACT_APP_NAME,
        parent_entity_related: ''
      });
      if (deleteDrugSupplyDoc) {
        await deleteDrugSupplyDoc({
          data: {
            filemaster_id: deleteDocFileMasterId.document_id,
            tmf_document_id: deleteDocFileMasterId.tmf_document_id
          },
          drug_supply_id: selectedRecordId,
          study_id: selectedStudy,
          application: process.env.REACT_APP_NAME,
          application_section: process.env.REACT_APP_CONDUCT_NAME,
          application_module_section: process.env.REACT_APP_CONDUCT_NAME
        });

        setDeleteFileMasterDocId({ document_id: '', tmf_document_id: '', fileMasterId: '' });
        setUploadDocDilogOpen(false);
        resetDocumentUpload();
      }
    } catch (error: any) {
      if (error && error?.response?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (error && error.response?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      } else {
        dispatch(setMessage({ msgDetails: 'Error in Deleting Document', severity: 'error' }));
      }
    }
    setIsLoading(false);
  };
  const onUploadDocFormSubmit = async (data: any) => {
    if (data.errors) {
      dispatch(setMessage({ msgDetails: `Missing mandatory data`, severity: 'error' }));
      return;
    }
    if (data.success) {
      setIsLoading(true);
      setDocSubmitEnabled(false);
      try {
        const tempMetaData = {
          tmf_artifact_number: data.records.tmf_artifact_number,
          tmf_document_name: data.records.tmf_document_name,
          tmf_doc_type: data.records.tmf_document_type,
          tmf_doc_subtype: data.records.tmf_document_subtype,
          tmf_doc_date: new Date().toISOString().split('T')[0],
          tmf_doc_country:
            data.records.tmf_doc_level === 'Country' || data.records.tmf_doc_level === 'Site'
              ? data.records.tmf_doc_country
              : null,
          tmf_doc_study: data.records.tmf_doc_study,
          tmf_doc_site: data.records.tmf_doc_level === 'Site' ? data.records.tmf_doc_site : null,
          tmf_doc_level: data.records.tmf_doc_level,
          tmf_artifact_name: data.records.tmf_artifact_name,
          tmf_doc_version_number: data.records.tmf_doc_version_number,
          tmf_doc_milestone: data.records.tmf_doc_milestone
        };
        setMetaData({ ...metaData, ...tempMetaData });
        const formData = new FormData();
        formData.append('file', data?.records?.document_upload[0]);

        const options = {
          endPointEnv: 'etmf',
          data: formData,
          pathVariables: {
            study_id: selectedStudy,
            appName: process.env.REACT_APP_NAME,
            audit_module_section: moduleSection,
            parent_entity_related: ''
          }
        };

        const uploadedFile: any = await sendRequest('drug_supply_add_doc_upload_file', options);
        setResData(uploadedFile);
        const docData: any = {
          file_master_id: uploadedFile.id,
          document_data: {
            ...tempMetaData,
            sent_to_isf: false,
            tmf_doc_status: 'Uploaded',
            tmf_doc_viewer_language: 'English',
            tmf_doc_viewer_approval_cycle: 0,
            tmf_doc_viewer_product_detail: 'string',
            tmf_doc_viewer_ref_model_version: 'TMF RM 3.2.1',
            tmf_doc_viewer_format: uploadedFile.tmf_doc_type,
            tmf_doc_viewer_inspection_ready: 'string',
            tmf_doc_viewer_ir_issue_type: 'string',
            tmf_doc_viewer_req_certified_copy: 'N',
            tmf_doc_viewer_department: 'None',
            tmf_doc_created_by: uploadedFile.tmf_doc_created_by,
            tmf_document_id: 'str'
          }
        };
        getDocumentDetails(tempMetaData, docData);
      } catch (e: any) {
        setDocSubmitEnabled(true);
        if (e?.response?.status == '422') {
          dispatch(setMessage({ msgDetails: e?.response?.data?.context?.message, severity: 'error' }));
        } else {
          dispatch(setMessage({ msgDetails: `Error while Document Uploading`, severity: 'error' }));
        }
      }
      setIsLoading(false);
    }
  };
  const handleUploadDocumentSubmit = () => {
    uploadDocumentFormRef.current.submit(onUploadDocFormSubmit);
  };
  const handleUploadDocClose = () => {
    setCancelDocPopup(true);
  };

  const handleCancelDocUpload = () => {
    setCancelDocPopup(false);
    setUploadDocDilogOpen(false);
    resetDocumentUpload();
  };

  const onUploadFormFieldsChange = async (key: string, value: any) => {
    if (key === 'document_upload' && value.length && value?.[0]?.path && Array.isArray(value)) {
      dispatch(setMessage({ msgDetails: `File ${value?.[0]?.path} successfully added.`, severity: 'success' }));
      uploadDocumentGroups.map((obj: any) => {
        obj?.fields.map((field: any) => {
          if (field.name == 'tmf_document_name' || field.name == 'tmf_artifact_name') {
            field.disabled = false;
          }
        });
      });
      setUploadInitialValues({
        ...uploadInitialValues,
        [key]: value,
        tmf_doc_version_number: '1.0',
        tmf_doc_date: preferedDateFormat(new Date().toISOString().split('T')[0])
      });
      setRefreshKey(prev => prev + 1);
    } else if (key === 'document_upload' && value?.length) {
      dispatch(setMessage({ msgDetails: value, severity: 'error' }));
    } else if (key === 'tmf_artifact_name') {
      setSelectedArtifact(value);
      setIsLoading(true);
      // Get Artifact details based on doc level and artifact name
      const result: any = await getDocLevelByArtifactName({
        tmf_doc_level: tmfLevel,
        tmf_artifact_name: value,
        application: process.env.REACT_APP_NAME,
        module_section_related: moduleSection,
        parent_entity_related: ''
      });
      if (result?.isSuccess) {
        setUploadInitialValues({
          ...uploadInitialValues,
          tmf_artifact_name: value,
          tmf_artifact_number: result?.data.tmf_artifact_number,
          tmf_document_subtype: result?.data.tmf_doc_subtype,
          tmf_document_type: result?.data.tmf_doc_type,
          tmf_doc_milestone: result?.data.tmf_doc_milestone
        });
        setRefreshKey(prev => prev + 1);
      } else if (result?.isError) {
        if (result?.error.status === 403) {
          dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
        } else if (result?.error.status === 401) {
          dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
        }
      }
      setIsLoading(false);
    } else {
      setUploadInitialValues({ ...uploadInitialValues, [key]: value });
    }
  };

  useEffect(() => {
    if (selectedStudy) {
      setUploadInitialValues({ ...uploadInitialValues, tmf_doc_level: tmfLevel, tmf_doc_study: selectedStudy });
      getTmfDataResponse(tmfLevel);
    }
  }, [selectedStudy]);

  const disableUploadDocField = () => {
    uploadDocGroups.map((obj: any) => {
      obj?.fields.map((field: any) => {
        if (field.name == 'document_upload') {
          field.disabled = false;
        }
      });
    });
  };
  useEffect(() => {
    if (attachedDocumentsList.length === 10) {
      disableUploadDocField();
    }
  }, [attachedDocumentsList.length]);

  useEffect(() => {
    if (!checkPermission('manage_drug_supply')) {
      disableUploadDocField();
    }
  }, []);

  useEffect(() => {
    if (uploadInitialValues) {
      if (uploadInitialValues.tmf_document_name && uploadInitialValues.tmf_artifact_name) {
        setDocSubmitEnabled(true);
      } else {
        setDocSubmitEnabled(false);
      }
    }
  }, [uploadInitialValues]);
  return (
    <>
      <div className="card">
        <AppModal
          open={uploadDocDialogOpen}
          title={uploadDocumentformGroup.header}
          handleSubmit={handleUploadDocumentSubmit}
          handleClose={handleUploadDocClose}
          outSideClickClose
          saveButton={'Submit'}
          closeButton={'Cancel'}
          maxWidth={'980px'}
          disabled={!docSubmitEnabled}
        >
          <Box
            sx={{
              '& .uploadFile p.MuiTypography-h5': {
                left: 0,
                marginTop: '80px !important'
              }
            }}
          >
            <div
              className={
                checkPermission('manage_drug_supply')
                  ? attachedDocumentsList.length >= 10
                    ? `noUploadCaseDARModel`
                    : isLoading
                    ? `noUploadCaseDARModel`
                    : ''
                  : `noUploadCaseDARModel`
              }
            >
              <FormLayoutBuilder
                initialValues={uploadInitialValues}
                rules={uploadeDocRules}
                ref={uploadDocumentFormRef}
                groups={uploadDocGroups}
                onChange={onUploadFormFieldsChange}
              />
            </div>
          </Box>
          {isLoading && <ProgressBar />}
          <br />
          <FormLayoutBuilder
            key={`importfile-${refreshKey}`}
            initialValues={uploadInitialValues}
            rules={uploadeDocumentRules}
            ref={uploadDocumentFormRef}
            groups={uploadDocumentGroups}
            onChange={onUploadFormFieldsChange}
          />
          <Box sx={{ my: 2 }} className="uploadDocChipWrapper withWrap maxShow3">
            {attachedDocumentsList.length ? (
              attachedDocumentsList.map((doc: any, index: number) => {
                return (
                  <Chip
                    size="small"
                    key={index}
                    label={doc.document_data.tmf_document_name}
                    variant="outlined"
                    onClick={() => openDoucmentViewer(doc)}
                    onDelete={
                      checkPermission('manage_drug_supply')
                        ? () =>
                            handleDocDelete(doc.file_master.id, doc.document_data.tmf_document_id, doc.document_data.id)
                        : undefined
                    }
                    color="primary"
                  />
                );
              })
            ) : (
              <></>
            )}
          </Box>
        </AppModal>
        <AppModal
          open={deleteDocPopup}
          title={'Delete Document'}
          handleSubmit={handleDocDeleteconfirm}
          handleClose={handleDocDeletePopupClose}
          outSideClickClose
          saveButton={'Yes'}
          closeButton={'No'}
          maxWidth={'500px'}
        >
          <Grid pb={1.5}>Are you sure you want to remove the document?</Grid>
        </AppModal>
        <AppModal
          open={cancelDocPopup}
          title={'Document Upload'}
          handleSubmit={handleCancelDocUpload}
          handleClose={() => setCancelDocPopup(false)}
          outSideClickClose
          saveButton={'Yes'}
          closeButton={'No'}
          maxWidth={'500px'}
        >
          <Grid pb={1.5}>Are you sure you want to cancel uploading document?</Grid>
        </AppModal>
      </div>
      {openVersion && (
        <PopupComponent maxWidth="sm" open={openVersion} child>
          <VersionControl
            resData={resData}
            metaData={metaData}
            selectData={selectData}
            setSelectData={setSelectData}
            setMetaData={setMetaData}
            handleCloseVersion={handleCloseVersion}
            handleBackVersion={handleBackVersion}
            artifactName={selectedArtifact}
            createDrugSupplyDoc={createDrugSupplyDoc}
            selectedRecordId={selectedRecordId}
          />
        </PopupComponent>
      )}
    </>
  );
}
